/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, unit: NonNullable<unknown>, period: NonNullable<unknown> }} Signup_Compare_AllowanceInputs */



/**
* | output |
* | --- |
* | "{amount} {unit}/{period}" |
*
* @param {Signup_Compare_AllowanceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_allowance = /** @type {((inputs: Signup_Compare_AllowanceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_AllowanceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
	return /** @type {LocalizedString} */ (`${i?.amount} ${i?.unit}/${i?.period}`)
});